<template>
  <div class="fullScreen">
    <div class="text-center pt-6">
      <h1>Solicitação de Atendimento do DSG.</h1>
      <h5><b>ZELADORIA</b></h5>
      <br />
      <form @submit.prevent="registrarSolicitacao()">
        <div class="md:col-4 md:col-offset-4">
          <div class="flex justify-content-center flex-wrap">
            <Button
              label="Voltar"
              icon="pi pi-arrow-circle-left"
              @click="goIntranet"
              class="p-button-raised p-button-text mr-2"
            />

            <Button
              label="Entrar"
              icon="pi pi-arrow-circle-right"
              iconPos="right"
              @click="$router.push('/system')"
              class="p-button-raised"
            />
          </div>

          <hr />
          <div class="p-fluid text-left">
            <div class="field">
              <label for="local">Local</label>
              <Dropdown
                id="local"
                :options="locals"
                optionLabel="name"
                class="p-inputtext-lg"
                placeholder="Selecione o local"
                :filter="true"
                v-model="solicitation.local"
                @change="findSectors"
              >
              </Dropdown>
            </div>
            <div class="field">
              <label for="sector">Setores</label>
              <Dropdown
                id="sector"
                :options="sectors"
                :optionLabel="label"
                class="p-inputtext-lg"
                placeholder="Selecione o setor"
                :filter="true"
                @filter="onFilter($event)"
                v-model="solicitation.sector"
              >
              </Dropdown>
            </div>
            <div class="field">
              <label for="credential">Matricula</label>
              <InputText
                id="credential"
                class="p-inputtext-lg"
                placeholder="Digite sua matricula (SEM O DÍGITO)"
                v-model="solicitation.requester.credential"
                @change="findPerson"
                required
              />
              <div v-if="solicitation.requester.id">
                <br />
                <Chip
                  :label="solicitation.requester.name"
                  :image="solicitation.requester.image"
                  class="mr-2 mb-2"
                />
              </div>
            </div>
            <div class="field">
              <label for="solicitation">Solicitação</label>
              <Textarea
                id="solicitation"
                class="p-inputtext-lg"
                placeholder="Digite sua solicitação"
                v-model="solicitation.description"
                rows="5"
                cols="30"
                :autoResize="true"
                required
              />
            </div>
            <div class="field">
              <Button
                label="ENVIAR"
                type="submit"
                :disabled="
                  !solicitation.requester.id || !solicitation.sector.id
                "
                class="p-button-lg p-button-success"
              />
            </div>
          </div>
          <hr />
          <div class="p-col-12 p-mt-4 hvr-grow">
            <h1
              class="p-text-center atendimento link-text"
              @click="abrirAvaliar"
            >
              Acompanhar e avaliar Atendimento.
            </h1>
          </div>
        </div>
      </form>
    </div>
  </div>
  <dialog-external-card />
  <Toast />
</template>

<script>
// Services
import SectorService from "../../service/sector/sector_service";
import PersonService from "../../service/person/person_service";
import SolicitationService from "../../service/solicitation/solicitation_service";
import LocalService from "../../service/local/local_service";

// Models
import Solicitation from "../../models/internal/solicitation";
import SolicitationDTO from "../../models/dto/solicitation_dto";

import DialogExternalCard from "./components/dialog_external_card.vue";

export default {
  components: { DialogExternalCard },
  data() {
    return {
      sectorService: new SectorService(),
      personService: new PersonService(),
      localService: new LocalService(),
      solicitationService: new SolicitationService(),
      sectors: [],
      locals: [],
      setoresFiltrados: [],
      solicitation: new Solicitation(),
      user: [],
    };
  },
  computed: {
    label() {
      return this.setoresFiltrados.length > 0 ? "acronym" : "name";
    },
  },
  created() {
    this.checkCookieSession();
  },
  mounted() {
    this.findLocals();
  },
  methods: {
    checkCookieSession() {
      let cookieToken = this.getCookie("access_token");
      let cookieLocal = this.getCookie("local");
      //VERIFICA SE POSSUE TOKEN NO COOKIE DO NAVEGADOR
      if (cookieToken && cookieLocal) {
        this.$store.dispatch("setUserLogged");
        this.user = this.$store.getters.getUserLogged;

        return true;
      } else {
        alert("Usuário desconectado! Você precisa fazer login novamente");
        return false;
      }
    },
    getCookie(name) {
      const cookies = document.cookie.split("; ");
      for (let cookie of cookies) {
        let [key, value] = cookie.split("=");
        if (key === name) {
          return decodeURIComponent(value);
        }
      }
      return null;
    },
    findPermission(p) {
      if (this.user.authorities) {
        let isPermited = this.user.authorities.filter((a) => a == p);
        return isPermited.length > 0;
      } else {
        return false;
      }
    },
    checkGroupPermission(p) {
      if (this.user.services) {
        let isPermited = this.user.services.filter(
          (a) => a.groupPermission == p
        );
        return isPermited.length > 0;
      } else {
        return false;
      }
    },
    findLocals() {
      this.localService
        .findAll()
        .then((res) => {
          this.locals = res;
        })
        .catch(() => {
          this.$toast.add({
            severity: "error",
            detail: `Desculpe. Não foi possível carregar os dados.`,
          });
        });
    },
    findSectors() {
      if (this.solicitation.local != null) {
        this.sectorService
          .findByLocal(this.solicitation.local.id)
          .then((data) => {
            this.sectors = data;
          })
          .catch(() => {
            this.$toast.add({
              severity: "error",
              detail: `Desculpe. Não foi possível carregar os dados.`,
            });
            this.sectors = [];
          });
      } else {
        this.sectors = [];
      }
    },
    findPerson() {
      this.personService
        .findByCpfOrCredential(this.solicitation.requester.credential)
        .then((data) => (this.solicitation.requester = data));
    },
    registrarSolicitacao() {
      this.solicitation.status = "EM_ABERTO";
      let dto = new SolicitationDTO(this.solicitation);
      dto.operator = null;
      dto.requester = this.solicitation.requester.id;
      this.solicitationService
        .registerSolicitation(dto)
        .then((res) => {
          if (res.status === 201) {
            this.$toast.add({
              severity: "success",
              summary: "Nº PROTOCOLO: 0000" + res.data.id + ".",
              detail: `Obrigado! ${res.data.requesterName} sua solicitação foi registrada com sucesso. Para acompanhar seu atendimento, selecione 'Acompanhar e Avaliar Atendimento' informando o número do protocolo.`,
            });
            this.solicitation = new Solicitation();
          }
        })
        .catch((error) => this.$msgErro(error));
    },
    abrirAvaliar() {
      // this.$store.commit("setSelectType", true);
      this.$store.commit("setDialogExternalCard", true);
    },
    selecionarTipo(tipo) {
      if (tipo == "atendimento") {
        this.$store.commit("setDialogExternalCard", true);
      } else {
        //this.$store.commit("setDialogCardExternoManutencao", true);
      }
    },
    onFilter(event) {
      if (!event.value) {
        this.setoresFiltrados = [];
      } else {
        this.setoresFiltrados = this.sectors.filter(
          (item) =>
            item.acronym.includes(event.value) ||
            item.name.includes(event.value)
        );
      }
    },
    goIntranet() {
      window.location = this.$UrlIntranet;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./components/styles.scss";
.link-custom {
  color: white;
  font-weight: bold;
  font-size: 24px;
}
</style>
